module.exports = __webpack_public_path__ + "static/first-f5eff2c5961171c776c844e4eac7f05a.png";